import '../../index.css';
var styles = {
  "textInputContainer": "bp_base_text_input_module_textInputContainer--452c9",
  "label": "bp_base_text_input_module_label--452c9",
  "hidden": "bp_base_text_input_module_hidden--452c9",
  "textInput": "bp_base_text_input_module_textInput--452c9",
  "error": "bp_base_text_input_module_error--452c9",
  "iconShared": "bp_base_text_input_module_iconShared--452c9",
  "disabled": "bp_base_text_input_module_disabled--452c9",
  "inlineError": "bp_base_text_input_module_inlineError--452c9"
};
export { styles as default };